import styled from 'styled-components';
import Section from '../../../components/Section';

const PaymentStatusInformation = () => {
  return (
    <SectionWrapper>
      <Section>
        <header>
          <h3>Status explanations</h3>
        </header>
        <InfoWrapper>
          <ul>
            <li>
              <span>Acknowledged: </span>
              SEB has recieved the message containing the payment
            </li>
            <li>
              <span>Booked: </span>
              SEB has scheduled the payment to go out
            </li>
            <li>
              <span>Fulfilled: </span>
              done
            </li>
            <li>
              <span>Pending: </span>
              Payment is on it's way to SEB
            </li>
          </ul>
        </InfoWrapper>
      </Section>
    </SectionWrapper>
  );
};

export default PaymentStatusInformation;

const InfoWrapper = styled.main`
  padding: 0.5rem;
  background-color: #fafafa;
  border-radius: 0.5rem;
  margin-left: 0;
  font-size: 0.875rem;

  ul {
    list-style: none;

    span {
      font-weight: 500;
    }
  }
`;

const SectionWrapper = styled.div`
  width: 40rem;
`;
